/**
 * 分类API服务
 */
import axios from 'axios';
import { getApiUrl, API } from './config';

/**
 * 获取分类列表
 * @param {Object} params - 查询参数 {page, limit}
 * @returns {Promise} - 返回分类列表数据
 */
export const getCategoryList = async (params = {}) => {
  try {
    const response = await axios.get(getApiUrl(API.CATEGORY + '/index'), { params });
    return response.data;
  } catch (error) {
    console.error('获取分类列表失败:', error);
    throw error;
  }
}; 